export default __webpack_public_path__ + "static/media/cnicImage.b027a974.jpg";